import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getServiceData = () => {
  return axios.get('/services');
};

export const useServiceData = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['service_data'],
    queryFn: () => getServiceData(),
  });
};
